import {useState, useRef} from 'react';

export default function useLongPress() {
  const [action, setAction] = useState('');

  const timerRef = useRef<NodeJS.Timeout>();
  const isLongPress = useRef(false);

  function startPressTimer() {
    isLongPress.current = false;
    timerRef.current = setTimeout(() => {
      isLongPress.current = true;
      setAction('longpress');
    }, 500);
  }

  function handleOnClick() {
    if (isLongPress.current) {
      return;
    }
    setAction('click');
  }

  function handleOnMouseDown() {
    startPressTimer();
  }

  function handleOnMouseUp() {
    timerRef.current && clearTimeout(timerRef.current);
  }

  function handleOnTouchStart() {
    startPressTimer();
  }

  const handleOnKeyDown = (): React.KeyboardEventHandler<HTMLButtonElement> | undefined | void => {
    return startPressTimer();
  };

  const handleOnKeyPress = (): React.KeyboardEventHandler<HTMLButtonElement> | undefined | void => {
    return startPressTimer();
  };

  function handleOnKeyUp() {
    timerRef.current && clearTimeout(timerRef.current);
  }

  function handleOnTouchEnd() {
    if (action === 'longpress') return;
    timerRef.current && clearTimeout(timerRef.current);
  }

  return {
    action,
    isLongPress,
    handlers: {
      onClick: handleOnClick,
      onkeydown: handleOnKeyDown,
      onkeyup: handleOnKeyUp,
      onkeypress: handleOnKeyPress,
      onMouseDown: handleOnMouseDown,
      onMouseUp: handleOnMouseUp,
      onTouchStart: handleOnTouchStart,
      onTouchEnd: handleOnTouchEnd,
    },
  };
}
